import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { themeDefaults } from './themeDefaults';
import { MuiButtonOverrides } from './ThemeOverrides/buttonOverrides';
import { MuiTableCellOverrides } from './ThemeOverrides/TableCellOverrides';
import { dialogOverrides } from './ThemeOverrides/dialogOverrides';
import { CoreTypographyThemeVariants } from './ThemeOverrides';
import { MuiButtonGroupOverrides } from './ThemeOverrides/buttonGroupOverrides';
import { MuiIconButtonOverrides } from './ThemeOverrides/iconButtonOverrides';
//TODO: determine if we need this
// import { mediaTypographyOverrides } from './ThemeOverrides/mediaTypographyOverrides';

var brightpathTempTheme = createTheme(themeDefaults);

// Add attributes that need access to the theme here
export var brightpathTheme = createTheme(deepmerge(themeDefaults, {
  components: {
    MuiButton: MuiButtonOverrides,
    MuiButtonGroupOverrides: MuiButtonGroupOverrides,
    MuiIconButton: MuiIconButtonOverrides,
    MuiDialog: dialogOverrides(brightpathTempTheme),
    MuiTableCell: MuiTableCellOverrides(brightpathTempTheme)
  },
  typography: CoreTypographyThemeVariants
}));
export default brightpathTheme;